import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../context/auth';
import moment from 'moment';

function Footer() {

  let op = require('../../src/modulos/datos');

  const { user } = useContext(AuthContext);
  const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
  const [usuario, setUsuario] = useState('');
  const [nomOrg, setNomOrg] = useState('');

  useEffect(() => {

    let obj = JSON.parse(localStorage.getItem('post'));
    setFechaSistema(obj.fechasistema);

    if (obj != null) {

      setUsuario(obj.login);
      setNomOrg(obj.nombreorg);

    } else {

      setUsuario('');
      setNomOrg('');

    }

  }, []);


  return user && (
    <footer className="container-fluid text-center amanecerfooter" id='gg'>
      <img src={op.imagenes + '/imagen?img=Logopsiap.png'} style={{ maxWidth: '80px'}} alt="footer" />
      <strong>Copyright &copy; {moment.utc().format('YYYY')} <a className='bluez-text' href="http://www.opensiap.com.ve" target="_blank">SYGRECA.</a>Todos los Derechos Reservados.</strong>
    </footer>
  )
}

export default Footer